/** @format */

import React, { Component } from 'react';
import {
  Segment,
  Divider,
  Header,
  Table,
  Button,
  Icon,
} from 'semantic-ui-react';
import { getDateFromTimestamp } from '../../../../helpers/getDateFromTimestamp';
import getTimestampFromDate from '../../../../helpers/getTimestampFromDate';
import { observer, inject } from 'mobx-react';

@inject('RequestsStore', 'UserStore', 'WarehousesStore')
@observer
class RequestCommunication extends Component {
  renderComunicationList = () => {
    let { RequestsStore } = this.props;
    const communication = RequestsStore.currentRequest.communication;
    let communicationList = communication.list;
    if (
      typeof communication === 'undefined' ||
      typeof communicationList === 'undefined' ||
      (communicationList && !communicationList.length)
    ) {
      return (
        <Table.Row>
          <Table.Cell>
            <small>
              Non sono avvenute ancora comunicazioni per questa richiesta
            </small>
          </Table.Cell>
        </Table.Row>
      );
    } else {
      return communication.list.map((communication, index) => {
        return (
          <Table.Row key={index}>
            <Table.Cell>
              {getDateFromTimestamp(communication.timestamp)}
            </Table.Cell>
            <Table.Cell>
              {communication.user ? communication.user : '-'}
            </Table.Cell>
            <Table.Cell>
              {communication.state === 'toRecall'
                ? 'Non ha risposto.'
                : 'Avvisato da richiamare'}
            </Table.Cell>
            <Table.Cell>
              {communication.note ? communication.note : '-'}
            </Table.Cell>
          </Table.Row>
        );
      });
    }
  };

  renderRecallAdvice = () => {
    let { RequestsStore } = this.props;

    if (
      RequestsStore.currentRequest.communication &&
      RequestsStore.currentRequest.communication.state === 'notified'
    ) {
      let currentUnixDate =
        RequestsStore.currentRequest.communication.recallDate +
        ' ' +
        RequestsStore.currentRequest.communication.recallHour +
        ':' +
        RequestsStore.currentRequest.communication.recallMinutes +
        ':00';
      let recallMoment = getTimestampFromDate(currentUnixDate);
      return (
        <p>
          Cliente Avvisato. Da Richiamare il{' '}
          {getDateFromTimestamp(recallMoment * -1)}
        </p>
      );
    } else if (
      RequestsStore.currentRequest.communication &&
      RequestsStore.currentRequest.communication.state === 'toRecall'
    ) {
      let currentUnixDate =
        RequestsStore.currentRequest.communication.recallDate +
        ' ' +
        RequestsStore.currentRequest.communication.recallHour +
        ':' +
        RequestsStore.currentRequest.communication.recallMinutes +
        ':00';
      let recallMoment = getTimestampFromDate(currentUnixDate);
      return (
        <p>
          Non ha risposto. Fissato Richiamo{' '}
          {getDateFromTimestamp(recallMoment * -1)}{' '}
        </p>
      );
    }
  };

  render() {
    let { RequestsStore } = this.props;
    return (
      <Segment key="request-comunication">
        <Header as="h3">Comunicazione con il cliente</Header>
        <Divider />
        {this.renderRecallAdvice()}
        <Table compact celled basic="very">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                <small>
                  <strong>Creazione</strong>
                </small>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <small>
                  <strong>Utente</strong>
                </small>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <small>
                  <strong>Esito Comunicazione</strong>
                </small>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <small>
                  <strong>Note Comunicazione</strong>
                </small>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{this.renderComunicationList()}</Table.Body>
        </Table>
        <Button
          onClick={() => RequestsStore.toggleCommunicationModal()}
          fluid
          size="small"
          color="green"
        >
          <Icon name="phone" /> Aggiungi Comunicazione
        </Button>
      </Segment>
    );
  }
}

export default RequestCommunication;
